import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

export default function animateOnScroll() {

    const animationMapping = {
        'fade-in': { opacity: 0 },
        'fade-out': { opacity: 1 },
        'blur': { filter: 'blur(5px)' },
        'up': { opacity: 0, y: "2rem" },
        'up-full': { opacity: 0, yPercent: 100 },
        'down': { opacity: 0, y: "-2rem" },
        'left': { opacity: 0, x: "-2rem" },
        'right': { opacity: 0, x: "2rem" },
        'text-split-up': (element) => {
            const split = new SplitText(element, { type: "words" });
            return { targets: split.words, from: { opacity: 0, y: "2rem" }, to: { opacity: 1, y: 0, stagger: 0.05 } };
        },
        'text-split-blur': (element) => {
            const split = new SplitText(element, { type: "words" });
            return { targets: split.words, from: { opacity: 0, filter: "blur(5px)" }, to: { opacity: 1, filter: "blur(0px)", stagger: 0.05 } };
        },
        'clip-path-top': {
            from: { 'clip-path': 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)' },
            to: { 'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' }
        },
        'clip-path-top-rev': {
            from: { 'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' },
            to: { 'clip-path': 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)' }
        },
        'clip-path-bottom': {
            from: { 'clip-path': 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)' },
            to: { 'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' }
        },
        'clip-path-left': {
            from: { 'clip-path': 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)' },
            to: { 'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' }
        },
        'clip-path-left-rev': {
            from: { 'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' },
            to: { 'clip-path': 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)' }
        },
        'clip-path-right': {
            from: { 'clip-path': 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)' },
            to: { 'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' }
        },
        'clip-path-right-rev': {
            from: { 'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' },
            to: { 'clip-path': 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)' }
        },
    };

    const scrollTriggerElements = document.querySelectorAll('[data-scroll-trigger]');

    scrollTriggerElements.forEach((triggerElement) => {
        const animateElements = triggerElement.querySelectorAll('[data-animation]');
        const triggerStartValue = triggerElement.getAttribute('data-scroll-trigger') || "200px";
        const triggerStart = `${triggerStartValue} bottom`;

        const tl = gsap.timeline({
            defaults: {
                ease: "power2.out",
                duration: 0.5,
            },
            scrollTrigger: {
                trigger: triggerElement,
                start: triggerStart,
                end: "bottom top",
            }
        });

        animateElements.forEach((element) => {
            const animationType = element.getAttribute('data-animation');
            const animationParams = animationMapping[animationType];

            if (animationParams) {
                if (typeof animationParams === 'function') {
                    const splitParams = animationParams(element);
                    tl.fromTo(splitParams.targets, splitParams.from, splitParams.to, "<50%");
                } else if (animationType.startsWith('clip-path')) {
                    tl.fromTo(element, animationParams.from, { ...animationParams.to, opacity: 1, duration: 1 }, "<50%");
                } else {
                    tl.from(element, animationParams, "<50%");
                }
            } else {
                console.warn(`Invalid animation type: ${animationType}`);
            }
        });
    });


    const elementsDraw = document.querySelectorAll('.line-gap > .line')

	elementsDraw.forEach((element) => {
		const settings = {
			scrollTrigger: {
				trigger: element,
				start: 'top bottom-=4%',
			},
			width: "0%",
			delay: 0.2,
			duration: 2,
			autoAlpha: 0,
			ease: 'slow(0.7,0.7,false)',
		}

		// Animation time
		gsap.from(element, settings)
	})



    const elementsIn = document.querySelectorAll('[data-animate-in]')

	elementsIn.forEach((element) => {
		const settings = {
			scrollTrigger: {
				trigger: element,
				start: 'top bottom-=4%',
			},
			y: 10,
			duration: 1,
			autoAlpha: 0,
		}

		// Animation time
		gsap.from(element, settings)
	})


    const elementsUp = document.querySelectorAll('[data-animate-up]')

	elementsUp.forEach((element) => {
		const settings = {
			scrollTrigger: {
				trigger: element,
				start: 'top bottom-=10%',
			},
			y: 36,
			duration: 1,
			autoAlpha: 0,
		}

		// Animation time
		gsap.from(element, settings)
	})



    const sections = document.querySelectorAll('.scroll-text-section');

    sections.forEach((section) => {
        const textElements = section.querySelectorAll('[data-animate-text]');
        
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top 95%",
                end: "+=100%",
                pin: false,
                scrub: true,
            }
        });
    
        // Handle each paragraph separately
        textElements.forEach((element) => {
            const splitText = new SplitText(element, { type: "words,chars" });
            
            tl.to(splitText.chars, {
                color: "#393C05",
                stagger: 0.05,
                duration: 1,
                ease: "none"
            }, "<+=0.3"); // Slight delay between paragraphs
        });
    });



    // Parallax effect for images
    const parallaxImages = document.querySelectorAll('[data-parallax]');

    parallaxImages.forEach((container) => {
        const img = container.querySelector('img');
        
        const settings = {
            scrollTrigger: {
                trigger: container,
                scrub: true,
                pin: false,
            },
            yPercent: 20,
            ease: 'none'
        }
    
        // Animation time
        gsap.fromTo(img, 
            {
                yPercent: -20,
                ease: 'none'
            },
            settings
        );
    });



    // Fade-in effect for boxes
    const fadeInBoxes = document.querySelectorAll('[data-fadein]');

    // Create a batch for all elements
    ScrollTrigger.batch(fadeInBoxes, {
        start: "top 85%",
        onEnter: (elements) => {
            gsap.to(elements, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                stagger: 0.15,
                ease: "power2.out",
                overwrite: true
            });
        },
        once: true
    });

    // Set initial state for all elements
    gsap.set(fadeInBoxes, {
        opacity: 0,
        y: 60
    });



    const fullImageSections = document.querySelectorAll('.full-image-section');

    fullImageSections.forEach((section) => {

        // Get the section height
        const sectionHeight = section.offsetHeight;
        const parentSection = section.closest('.sets-up-area');
        
        // Set minimum height to parent section to accommodate the animation
        if (parentSection) {
            parentSection.style.minHeight = `${sectionHeight * 2}px`; // Multiply by 2 to account for the animation space
        }

        const scaleImg = section.querySelector('.scale-imgs');
        const stackTop = section.querySelector('.stack-top');
    
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top top",
                end: "+=100%",
                scrub: 1,
                pin: true,
                pinSpacing: true,
                markers: false,
                toggleActions: "play none none reverse"
            }
        });
    
        timeline.fromTo(scaleImg, 
            {
                scale: 0.7
            },
            {
                scale: 1,
                ease: "none",
                duration: 1,
                overwrite: true
            }, 0
        ).fromTo(stackTop, 
            {
                y: "120%"
            },
            {
                y: 0,
                ease: "none",
                duration: 1,
                overwrite: true
            }, 0
        );
    });
    




}

